import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

// Correct Base Route
const serverUrl = `${BaseUrl}/webArrival`

// ---------------------------------------------
// Create New Arrival
// ---------------------------------------------
export const addNewArrivalApi = (formData) => {
  return axiosInstance.post(`${serverUrl}`, formData)
}

// ---------------------------------------------
// Update New Arrival
// ---------------------------------------------
export const updateNewArrivalApi = (id, formData) => {
  return axiosInstance.put(`${serverUrl}/${id}`, formData)
}

// ---------------------------------------------
// Add or Update Product inside NewArrival
// ---------------------------------------------
export const addOrUpdateProductApi = (arrivalId, formData) => {
  return axiosInstance.put(`${serverUrl}/${arrivalId}/add-product`, formData)
}

// ---------------------------------------------
// Remove Product from NewArrival
// ---------------------------------------------
export const removeProductApi = (arrivalId, formData) => {
  return axiosInstance.put(`${serverUrl}/${arrivalId}/remove-product`, formData)
}

// ---------------------------------------------
// DELETE Entire NewArrival
// ---------------------------------------------
export const deleteNewArrivalApi = (id) => {
  return axiosInstance.delete(`${serverUrl}/${id}`)
}

// ---------------------------------------------
// Get FULL NewArrival object by VendorId
// (includes _id + products)
// ---------------------------------------------
export const getNewArrivalByUserApi = (userId) => {
  return axiosInstance.get(`${serverUrl}/single/${userId}`)
}

// ---------------------------------------------
// Get products merged list for vendor (without _id)
// ---------------------------------------------
export const getVendorNewArrivalProductsApi = (userId) => {
  return axiosInstance.get(`${serverUrl}/getNewArr/${userId}`)
}

// ---------------------------------------------
// ADMIN: Get all products from all vendors
// ---------------------------------------------
export const getAllNewArrivalAdminApi = (params) => {
  return axiosInstance.get(`${serverUrl}/getNewArrAdmin`, { params })
}

const NewArrivalService = {
  addNewArrival: addNewArrivalApi,
  updateNewArrival: updateNewArrivalApi,
  addOrUpdateProduct: addOrUpdateProductApi,
  removeProduct: removeProductApi,
  deleteNewArrival: deleteNewArrivalApi,
  getNewArrivalByUser: getNewArrivalByUserApi,
  getVendorNewArrivalProducts: getVendorNewArrivalProductsApi,
  getAllNewArrivalAdmin: getAllNewArrivalAdminApi
}

export default NewArrivalService
